import { SVGProps, Ref, forwardRef } from 'react';

export const LabelEyeFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M8 6.333c-1.25 0-1.667.834-1.667 1.667S6.75 9.667 8 9.667 9.667 8.833 9.667 8a2.1 2.1 0 0 0-.089-.625c-.095.17-.276.292-.578.292-.5 0-.667-.334-.667-.667 0-.23.08-.461.295-.581A2.2 2.2 0 0 0 8 6.333"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 .667C2.5.667.667 4.333.667 8S2.5 15.333 8 15.333 15.333 11.667 15.333 8 13.5.667 8 .667M3 8c.208.833 2.5 3.333 5 3.333s4.792-2.5 5-3.333c-.208-.833-2.5-3.333-5-3.333S3.208 7.167 3 8"
                fill="currentColor"
            />
        </g>
    </svg>
));
LabelEyeFilledSize16Glyph.displayName = 'LabelEyeFilledSize16Glyph';
